<mat-dialog-content>
  <mat-stepper
    [selectedIndex]="currentStepIndex()"
    [linear]="true"
    orientation="horizontal"
    labelPosition="bottom">
    <ng-template matStepperIcon="done" let-index="index">
      <span aria-hidden="true">{{ index + 1 }}</span>
    </ng-template>

    <mat-step [editable]="false">
      <ng-template matStepLabel>
        <div class="step-label">Welcome</div>
        <div class="step-sub-label">Introduction to Toolhive</div>
      </ng-template>
      <mat-divider></mat-divider>
      <main class="welcome-step">
        <h4 class="display-text">Welcome to Toolhive</h4>
        <div class="header-text">
          <p>You're all set to manage your tools and assemblies in one place.</p>
          <p>
            To get the most out of your account, please complete the step wizard on the next
            screens.
          </p>
        </div>

        <div class="btn-footer">
          <button
            mat-flat-button
            color="primary"
            [disabled]="isSaving()"
            (click)="advanceToStatus(onboardingStatus.MeasurementSystemStep)">
            @if (isSaving()) {
              <mat-progress-spinner diameter="20" mode="indeterminate" />
            } @else {
              <span>Next</span>
            }
          </button>
        </div>
      </main>
    </mat-step>

    <mat-step [editable]="false">
      <ng-template matStepLabel>
        <div class="step-label">Measurement system</div>
        <div class="step-sub-label">Select your preferred units</div>
      </ng-template>
      <tfs-user-onboarding-measurement-system
        (next)="advanceToStatus(onboardingStatus.DataPreferenceStep)" />
    </mat-step>

    <mat-step [editable]="false">
      <ng-template matStepLabel>
        <div class="step-label">Data preference</div>
        <div class="step-sub-label">Configure data settings</div>
      </ng-template>
      <tfs-user-onboarding-data (next)="advanceToStatus(onboardingStatus.Onboarded)" />
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
